import React from 'react'
const content = {
  checkinfo: (
    <>
      Die Gemüse und Früchte in dieser Übersicht werden <b>mehrmals jährlich</b>{' '}
      auf ihre <b>tatsächliche Erhältlichkeit aus der Schweiz</b> hin überprüft.
      Das bedeutet, dass in einem vergleichsweise kalten Frühling Spargeln erst
      im späten April (und nicht schon wie oft vorher) als «aktuell erhältlich»
      eingestuft sind.
    </>
  ),
  text: (
    <>
      <p>
        Wer saisonal kocht, tut damit Gutes &mdash; in vielerlei Hinsicht: Es
        werden so weniger Flugzeuge mit exotischen Ananas und Avocados befüllt.
        Zig LKW-Kilometer (etwa zwischen Spanien und der Schweiz) können
        eingespart werden. Es müssen weniger Gewächshäuser energieaufwendig
        beheizt werden. Und sowieso: Wo wird wohl weniger Verpackungsmaterial
        gebraucht? Wenn Gurken aus Marokko einzeln verpackt hierhergekarrt
        werden? Oder wenn der Bauer eine einfache Holzkiste damit befüllt und
        das Gemüse selbst verkauft? Sowieso schön, demjenigen in die Augen zu
        blicken, der die Kartoffeln mit den eigenen Händen ausgegraben hat.
      </p>
      <p>
        Saisonales Obst und Gemüse zu essen, ist auch eine Frage des
        höchstmöglichen Genusses: Der Unterschied zwischen gartenfrischen
        Tomaten, die vielleicht sogar noch warm von der Sonne sind, und den
        importierten Exemplaren aus dem Kühlschrank im Februar ist immens.
      </p>
      <p>
        Womöglich sparen wir mit regionalen Produkten sogar Geld: Auch wenn
        immer wieder behauptet wird, dass der Einkauf hiesiger Ware teurer
        ausfällt - es stimmt am Ende des Tages nicht. Kaufe ich Kohlrabi oder
        Kopfsalat saisonal auf dem Wochenmarkt, werden sie einige Tage länger
        frisch und anmächelig bleiben. Die Wahrscheinlichkeit, dass man sie
        wegwerfen muss, wird kleiner. Und damit der Food-Waste.
      </p>
      <p>
        Nicht zu vergessen: Es macht einfach Freude, beim Essen mit den
        Jahreszeiten mitzugehen! Wie gut schmecken die ersten Spargeln mit einer
        selbstgemachten Sauce Hollandaise, wenn man bis in den späten April auf
        die regionalen Anbieter gewartet hat? Wie wunderbar sind die ersten
        Walliser Aprikosen, wenn sie möglichst reif geerntet und auf dem
        schnellstmöglichen Weg zur Kundschaft gebracht wurden? Das Gleiche gilt
        für die Suppe aus den ersten Kürbissen im Herbst. Oder für den
        Nüsslisalat aus Freilandanbau, wenn der Winter anbricht.
      </p>
      <p>
        Wer saisonal einkauft, tut unbestritten Gutes. Und in dem Sinne hoffen
        wir, mit diesem stetig aktualisierten Obst- und Gemüsekalender unseren
        Beitrag zu einer nachhaltigen Ernährung und zu mehr Genuss geleistet zu
        haben.
      </p>
      <iframe
        height='200px'
        width='100%'
        frameBorder='no'
        scrolling='no'
        seamless
        src='https://player.simplecast.com/dd6139ea-1d5b-44ff-84ea-061ae1917cc8?dark=true&color=479260'
      ></iframe>
    </>
  )
}

export default content
